var map = {
	"./colour-aubergine.png": "055a",
	"./colour-base-colours.png": "461c",
	"./colour-berry.png": "a666",
	"./colour-charcoal.png": "5118",
	"./colour-cupcake.png": "4408",
	"./colour-mozzarella.png": "5353",
	"./colour-orange.png": "6e7d",
	"./colour-tomato.png": "e060",
	"./colour-turmeric.png": "f5f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "678b";